import moment from 'moment/moment';

const useDateFormat =
  () =>
  (date: string, format = 'DD.MM.YYYY'): string =>
    date ? moment(date).format(format) : '???';

export default useDateFormat;
